/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Seating_UndoneInputs */



/**
* | output |
* | --- |
* | "Move undone" |
*
* @param {Rounds_Seating_UndoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_undone = /** @type {((inputs?: Rounds_Seating_UndoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_UndoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déplacement annulé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Movimiento deshecho")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Movimento desfeito")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spostamento annullato")
	return /** @type {LocalizedString} */ ("Move undone")
});